import { Box } from 'braid-design-system';

export const CardMobileView = ({ children }: { children: React.ReactNode }) => (
  <Box padding="medium" boxShadow="borderNeutralLight" borderRadius="large">
    {children}
  </Box>
);
